module.exports = __webpack_public_path__ + "img/0043.d16e49fe.gif";